module.exports = __webpack_public_path__ + "img/after_banner.6fbb3254.png";